import { useEffect, useState } from "react";
import { Building2, Pencil, Plus, ShieldCheck, ShieldOff } from "lucide-react";
import { call, formatError, date } from "@/lib/api";
import { Modal, PageHeader } from "@/components/common";

export default function MasterDivisions({ toast }) {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ name:"", description:"" });
  const [busy, setBusy] = useState(false);
  const load = () => call.get("/divisions").then(setItems);
  useEffect(() => { load(); }, []);
  const run = async (fn, msg) => { setBusy(true); try { await fn(); await load(); setModal(null); toast(msg); } catch (e) { toast(formatError(e), "error"); } finally { setBusy(false); } };
  return (
    <div data-testid="master-divisions">
      <PageHeader subtitle="Master divisi perusahaan — dinamis, dipakai untuk user dan tim project." />
      <div className="module-toolbar">
        <div className="filter-tabs"><button className="selected">Semua<b>{items.length}</b></button></div>
        <button className="primary-btn small" data-testid="add-division-button" onClick={() => { setForm({ name:"", description:"" }); setModal({ type:"create" }); }}><Plus size={15} /> Tambah Divisi</button>
      </div>
      <div className="panel data-panel"><div className="data-list">
        {items.map((d, i) => (
          <div className={`data-item account-row ${d.active ? "" : "inactive"}`} key={d.id} data-testid={`division-item-${i}`}>
            <div className="data-main"><span className="row-icon"><Building2 size={16} /></span><div><b>{d.name}</b><small>{d.id} · {d.description || "—"} · dibuat {date(d.created_at)} · update {date(d.updated_at)}</small></div></div>
            <div className="data-value" style={{fontSize:12}}>{d.member_count} user</div>
            <span className={`status ${d.active ? "status-active" : "status-rejected"}`}>{d.active ? "Aktif" : "Nonaktif"}</span>
            <div className="row-actions">
              <button className="ghost-btn pdf-btn" data-testid={`edit-division-${i}`} onClick={() => { setForm({ name:d.name, description:d.description || "" }); setModal({ type:"edit", d }); }}><Pencil size={13} /> Edit</button>
              <button className={`ghost-btn pdf-btn ${d.active ? "danger" : ""}`} data-testid={`toggle-division-${i}`} onClick={() => run(() => call.put(`/divisions/${d.id}`, { active: !d.active }), d.active ? "Divisi dinonaktifkan" : "Divisi diaktifkan")}>{d.active ? <><ShieldOff size={13} /> Nonaktifkan</> : <><ShieldCheck size={13} /> Aktifkan</>}</button>
            </div>
          </div>
        ))}
      </div></div>
      {modal && <Modal title={modal.type === "create" ? "Tambah Divisi" : `Edit Divisi · ${modal.d.name}`} onClose={() => setModal(null)} busy={busy} testid="division-modal"
        onSubmit={() => run(() => modal.type === "create" ? call.post("/divisions", form) : call.put(`/divisions/${modal.d.id}`, form), modal.type === "create" ? "Divisi dibuat" : "Divisi diperbarui")}>
        <div className="form-grid single">
          <label>Nama Divisi<input required minLength={2} data-testid="division-name-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></label>
          <label>Deskripsi<textarea data-testid="division-desc-input" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} /></label>
        </div>
      </Modal>}
    </div>
  );
}
